export default __webpack_public_path__ + "static/media/addScheduleWhite.b5c7e847.svg";